import ImageCallOut from "./ImageCallOut";
export default ImageCallOut;
